<template>
  <main class="main" role="main">
    <header class="header">
      <div class="inner">
        <div class="left">
          <button class="h_btn i_back" @click="goHome"></button>
        </div>
        <h1 class="h1">견적 요청서 관리</h1>
        <div class="right"></div>
      </div>
    </header>
    <div class="main_con customer_estimation_manage">
      <div ref="dummy"></div>
      <div class="new_est_wrap">
        <div class="new_est">
          <div class="new_est_img">
            <img src="@/assets/front/images/new/i_plus_dark_g.svg" alt="" />
          </div>
          <router-link
            :to="{ name: 'Estimation.Form' }"
            tag="button"
            class="new_est_txt"
            >새 요청서 작성</router-link
          >
        </div>
      </div>
      <h1 class="con_ttl" style="margin: 2rem 0 2rem;">
        <!-- <div class="msg bg">
          <div>저장하신 요청서는 매장과 상담 시 전달하여,</div>
          <div>손쉽게 상담을 받을 수 있도록 도와드립니다.</div>
          <div class="btn_wrap">
            <button class="btn" @click.stop="handleShops">
              지금, 상담을 받으러 가보세요!
            </button>
          </div>
        </div> -->
        <div class="new_est_img" @click.stop="handleShops">
          <img src="@/assets/front/images/new/img_banner_estimate.png" alt="" />
        </div>
      </h1>
      <div class="request_list">
        <div
          class="request_card"
          v-for="(item, index) in list"
          v-bind:key="index"
        >
          <div class="request_table">
            <button
              class="btn_delete"
              @click="removeEstimation({ id: item.id })"
            >
              삭제
            </button>
            <div class="request_date">
              {{ item.createdAt }} | 휴대폰견적요청서
            </div>
            <EstimationCard :item="item"></EstimationCard>
          </div>
          <div class="txt_box">
            <div class="txt" v-if="!item.requestedAt">
              우리동네 매장들에게<br />
              견적을 받아보시겠어요?
            </div>
            <div class="btn_wrap" v-if="!item.requestedAt">
              <button class="btn" @click.stop="sendShopList(item)">
                네 (견적요청)
              </button>
            </div>
            <div class="txt" v-if="item.requestedAt">
              우리동네 매장들에게<br />
              견적을 요청한 건입니다.
            </div>
          </div>
        </div>
        <infinite-loading
          ref="infiniteLoading"
          :direction="direction"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <span slot="no-more"></span>
          <span slot="no-results"></span>
          <span slot="spinner"></span>
        </infinite-loading>
      </div>
      <template v-if="fetchCompleted && list.length == 0">
        <div class="empty_wrap">
          <div class="empty">
            <!--'기본: ', '준비중: ready', '결과없음: result'-->
            <div class="msg">
              <div>요청한 견적이 없습니다.</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </main>
</template>

<script>
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimateActions from '@common/store/modules/estimate/types';
import * as getters from '@common/store/modules/estimate/getters';
import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import { mapActions as chatMapActions } from '@common/store/modules/chat';
import * as chatTypes from '@common/store/modules/chat/types';
import EstimationCard from '@/front/customer/views/estimation/components/EstimationCard';
import InfiniteLoading from 'vue-infinite-loading';

import {
  mapActions as shopMapActions,
  mapState as shopMapState,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

export default {
  components: {
    EstimationCard,
    InfiniteLoading,
  },
  name: 'EstimationForm',
  data() {
    return {
      direction: 'top',
      infiniteId: 0,
      first: true,
      fetchCompleted: false,
      list: [],
      size: 10,
      page: 1,
      TARGET_NAME_ENUM: [
        { value: 1, name: '본인' },
        { value: 2, name: '부' },
        { value: 3, name: '모' },
        { value: 4, name: '자녀' },
      ],
      TELECOM_MAINTANCE_ENUM: [
        { value: 1, name: '네' },
        { value: 2, name: '아니오' },
        { value: 3, name: '모르겠음' },
      ],
      DATA_USAGE_ENUM: [
        { value: 1, name: '6만 원이상' },
        { value: 2, name: '4~5만 원대' },
        { value: 3, name: '3만 원대' },
        { value: 4, name: '3만 원 미만' },
        { value: 5, name: '모르겠음' },
      ],
      INTERNET_USAGE_ENUM: [
        { value: 1, name: 'SKB' },
        { value: 2, name: 'KT' },
        { value: 3, name: 'LGU' },
        { value: 4, name: '지역방송' },
        { value: 5, name: '모르겠음' },
        { value: 6, name: '이용안함' },
      ],
    };
  },
  async created() {
    await this.getShops();
  },
  mounted() {
    //this.getEstimationList();
    this.infiniteId += 1; //리스트 가져오기.
  },
  computed: {
    ...shopMapGetters({
      shops: shopTypes.SHOPS,
      shopInfo: shopTypes.SHOP,
      shopCnt: shopTypes.SHOP_COUNT,
    }),
    ...estimateMapGetters({
      estimationList: estimateActions.ESTIMATION_LIST,
    }),
  },
  methods: {
    ...shopMapActions([shopTypes.FETCH_SHOPS]),
    ...estimateMapActions([
      estimateActions.FETCH_ESTIMATION_LIST,
      estimateActions.DELETE_ESTIMATION,
    ]),
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...chatMapActions([chatTypes.SEND_ESTIMATE]),
    goHome() {
      this.$router.push({ name: 'Home' });
    },
    // 관심매장 견적서 보내기
    async sendEstimate(item) {
      const payload = {
        estimateId: item.id,
      };
      const res = await this[chatTypes.SEND_ESTIMATE](payload);
      this.getListPageOne();
    },
    // 견적 보낼 매장 리스트 페이지로 이동
    sendShopList(item) {
      console.log('shopcnt = ' + this.shopCnt);
      console.log(this.shops.totalElements);
      console.log(1);

      // if (this.shops.totalElements > 0) {
      this.$router.push({
        name: 'Shops.listsend',
        query: { estimateId: item.id, estimateManage: true },
      });
      // }
    },
    async getShops() {
      const params = {
        page: 1,
        size: 10,
      };
      await this[shopTypes.FETCH_SHOPS](params);
    },
    async removeEstimation(id) {
      this[commonActions.SET_DIALOG]({
        type: 'confirm',
        icon: 'warning',
        //title: this.$t('common.confirm'),
        message: `삭제하시겠습니까?`,
        okCb: async () => {
          await this[estimateActions.DELETE_ESTIMATION](id).then(() => {
            this.getListPageOne();
            this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
          });
        },
      });
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      console.log(`infiniteId${this.infiniteId}`);
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getEstimationList();

        if (this.page == 1) {
          this.list = [];
        }
        if (this.estimationList.content.length) {
          this.list.push(...this.estimationList.content);
          if (this.page == 1) {
            setTimeout(() => {
              this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
              //window.scrollTo(0, 0);
            }, 10);
          }
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    async getEstimationList() {
      await this[estimateActions.FETCH_ESTIMATION_LIST]({
        page: this.page,
        size: this.size,
        type: 'DEFAULT',
      });
      this.fetchCompleted = true;
    },
    convertCodeToName(value, type) {
      return type.find(d => d.value === value).name;
    },
    handleShops() {
      this.$router.push({ path: '/Shops' }).catch(err => {});
    },
  },
};
</script>
